// This import loads the firebase namespace along with all its type information.
import Player from './player-model'

export async function load_players(): Promise<Player[]> {
  throw 'Not implemented'
}

export async function delete_player(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_player(): Promise<Player> {
  throw 'Not implemented'
}
